// src/index.js
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import keycloak from './keycloak';

/* DEV-ONLY: set REACT_APP_SKIP_AUTH=true in .env.local to bypass Keycloak */
const skipAuth = process.env.REACT_APP_SKIP_AUTH === 'true';
const mockKeycloak = {
  token: null,
  tokenParsed: { preferred_username: 'dev' },
  login: () => {},
  onTokenExpired: null,
};
/* END DEV-ONLY */

const Index = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(skipAuth);
  const [authInitialized, setAuthInitialized] = useState(skipAuth);

  // Refactorizar handleAuthentication con useCallback
  const handleAuthentication = useCallback((authenticated) => {
    setIsAuthenticated(authenticated);
    setAuthInitialized(true);

    if (authenticated) {
      console.log('Usuario autenticado:', keycloak.tokenParsed?.preferred_username);
      keycloak.onTokenExpired = handleTokenExpiration;
    } else {
      console.log('Usuario no autenticado');
      keycloak.login(); // Redirigir al login si no está autenticado
    }
  }, []); // Se puede dejar vacío si no depende de ningún estado o prop

  const handleTokenExpiration = () => {
    console.log('Token expirado, actualizando...');
    keycloak.updateToken(30).catch(() => {
      console.error('No se pudo actualizar el token');
    });
  };

  useEffect(() => {
    /* DEV-ONLY */
    if (skipAuth) return;
    /* END DEV-ONLY */

    const initKeycloak = async () => {
      try {
        const initOptions = getKeycloakInitOptions();
        const authenticated = await keycloak.init(initOptions);
        handleAuthentication(authenticated);
      } catch (error) {
        console.error('Error al inicializar Keycloak:', error);
        setAuthInitialized(true);
      }
    };

    initKeycloak();
  }, [handleAuthentication]); // Agregar handleAuthentication a las dependencias

  const getKeycloakInitOptions = () => {
    return {
      checkLoginIframe: false, // Deshabilitar iframe check
      pkceMethod: 'S256',      // Usar PKCE para mayor seguridad
      enableLogging: true,     // Habilitar logs para depuración
      silentCheckSsoFallback: false, // No mostrar login si falla el SSO silencioso
      flow: 'standard'         // Usar flujo estándar
    };
  };

  if (!authInitialized) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Inicializando autenticación...</p>
      </div>
    );
  }

  // return <App keycloak={keycloak} isAuthenticated={isAuthenticated} />;
  /* DEV-ONLY */
  return <App keycloak={skipAuth ? mockKeycloak : keycloak} isAuthenticated={isAuthenticated} />;
  /* END DEV-ONLY */
};

// Si estás usando React 18, debes usar createRoot en lugar de ReactDOM.render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>
);
